import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
const defaultModalProps = {};
function ModalOpenProcessInternal({ Modal, modalProps = defaultModalProps, }, forwardedRef) {
    const [{ isOpen, props }, setState] = React.useState({ isOpen: false, props: {} });
    React.useImperativeHandle(forwardedRef, () => ({
        open: props => {
            setState({ isOpen: true, props: props ?? {} });
        },
    }));
    return isOpen ? (
    // @ts-ignore
    _jsx(Modal, { ...modalProps, ...props, handleClose: () => {
            modalProps?.handleClose?.();
            setState({ isOpen: false, props: {} });
        } })) : null;
}
export const ModalOpenProcess = React.memo(React.forwardRef(ModalOpenProcessInternal));
//# sourceMappingURL=ModalOpenProcess.js.map